var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { SaveModuleConfigModel } from 'src/app/modules/models/save-module-config.model';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { SaveModule, ResetModules, GetModuleSecondaryCategories, SaveModuleSuccess, SaveModuleFailure } from 'src/app/modules/state/modules.actions';
import { ModulesState } from 'src/app/modules/state/modules.state';
import { Observable, Subject, combineLatest, of, merge } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { takeUntil, debounceTime, map, switchMap, tap } from 'rxjs/operators';
import { ModulesService } from 'src/app/modules/modules.service';
import { MatDialogRef, MatSnackBar } from '@angular/material';
var validString = '[0-9a-zA-Z_]*';
var validRegex = /^[0-9a-zA-Z_]+$/;
var SaveModuleDialogComponent = /** @class */ (function () {
    function SaveModuleDialogComponent(store, actions, formBuilder, modulesService, changeDetector, snackbar, dialogRef, data) {
        this.store = store;
        this.actions = actions;
        this.formBuilder = formBuilder;
        this.modulesService = modulesService;
        this.changeDetector = changeDetector;
        this.snackbar = snackbar;
        this.dialogRef = dialogRef;
        this.data = data;
        this.moduleExists = false;
        this.validating = false;
        this.ngUnsubscribe = new Subject();
        this.settings = __assign({}, data);
    }
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formName", {
        get: function () {
            return this.form.get('name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formStates", {
        get: function () {
            return this.form.get('states');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formPrimaryCategory", {
        get: function () {
            return this.form.get('primaryCategory');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formSecondaryCategory", {
        get: function () {
            return this.form.get('secondaryCategory');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formDuplicateStates", {
        get: function () {
            return this.form.get('duplicateStates');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formTrimGraph", {
        get: function () {
            return this.form.get('trimGraph');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveModuleDialogComponent.prototype, "formConfirmProduction", {
        get: function () {
            return this.form.get('confirmProduction');
        },
        enumerable: true,
        configurable: true
    });
    SaveModuleDialogComponent.prototype.ngOnInit = function () {
        this.store.dispatch(new ResetModules());
        this.saveModule = this.generateSaveModule();
        this.usedStates = this.modulesService.getUsedStates();
        this.initApplicationListeners();
        this.initForm();
        this.setFormValidators();
        this.initFormListeners();
        this.setFormValues(this.saveModule);
        this.populateStateValues();
    };
    SaveModuleDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SaveModuleDialogComponent.prototype.initApplicationListeners = function () {
        var _this = this;
        this.actions
            .pipe(ofActionDispatched(SaveModuleSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleSaveSuccess(action.id);
        });
        this.actions
            .pipe(ofActionDispatched(SaveModuleFailure), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleSaveFail(action.id);
        });
    };
    SaveModuleDialogComponent.prototype.initFormListeners = function () {
        var _this = this;
        this.formPrimaryCategory.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) {
            _this.store.dispatch(new GetModuleSecondaryCategories(value));
        });
        // Listens to the name field to check for a previously existing file. This
        // indicates whether you're saving a new file, or saving over on that exists.
        combineLatest(this.formPrimaryCategory.valueChanges, this.formSecondaryCategory.valueChanges, this.formName.valueChanges, this.formDuplicateStates.valueChanges)
            .pipe(takeUntil(this.ngUnsubscribe), debounceTime(300))
            .subscribe(function (_a) {
            var _b = __read(_a, 4), primaryCategory = _b[0], secondaryCategory = _b[1], name = _b[2], duplicateStates = _b[3];
            _this.handleNameChange(primaryCategory, secondaryCategory, name, duplicateStates);
        });
        // Listens to the state fields to check for previous existing states. States cannot be overridden,
        // so the user is warned when there is a matc and saving is blocked. 
        merge(this.formDuplicateStates.valueChanges, this.formStates.valueChanges)
            .pipe(tap(function () { return _this.validating = true; }), debounceTime(300), switchMap(function (values) {
            return _this.checkStateGroups();
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (validatedState) {
            _this.validating = false;
            _this.updateFormStates(validatedState);
        });
    };
    SaveModuleDialogComponent.prototype.initForm = function () {
        this.form = this.formBuilder.group({
            primaryCategory: ['', Validators.required],
            secondaryCategory: [''],
            name: ['', [Validators.required, Validators.pattern(validString)]],
            trimGraph: [false],
            duplicateStates: [false],
            confirmProduction: [false, this.validateProductionSave],
            states: this.formBuilder.array([
                this.initStateForm('')
            ])
        }, {
            validators: [this.validateProductionSave]
        });
    };
    SaveModuleDialogComponent.prototype.initStateForm = function (state) {
        return this.formBuilder.group({
            include: [true],
            oldState: [state],
            newState: [state, [Validators.required, Validators.pattern(validString)]]
        });
    };
    SaveModuleDialogComponent.prototype.handleReplaceClick = function (value) {
        this.changeStatePrefix(value, 'replace');
    };
    SaveModuleDialogComponent.prototype.handlePrependClick = function (value) {
        this.changeStatePrefix(value, 'prepend');
    };
    SaveModuleDialogComponent.prototype.handleSubmit = function () {
        if (this.form.valid) {
            this.save();
        }
    };
    SaveModuleDialogComponent.prototype.handleSaveSuccess = function (id) {
        this.dialogRef.close();
        this.snackbar.open("\"" + id + "\" successfully saved.");
    };
    SaveModuleDialogComponent.prototype.handleSaveFail = function (id) {
        this.snackbar.open("There was an error saving \"" + id + "\".");
    };
    // Generate a save module model from the passed id
    SaveModuleDialogComponent.prototype.generateSaveModule = function () {
        var module = this.modulesService.generateSaveModule(this.settings.id);
        return module;
    };
    SaveModuleDialogComponent.prototype.populateStateValues = function () {
        var _this = this;
        // Clear out previous states, rebind with new values
        while (this.formStates.length > 0) {
            this.formStates.removeAt(0);
        }
        var states = [];
        this.modulesService.getUsedStates()
            .forEach(function (state) {
            var stateControl = { enabled: true, state: state };
            _this.formStates.push(_this.initStateForm(stateControl.state));
            states.push(stateControl);
        });
        this.formStates.markAsDirty();
        // this.handleStatesChange(states);
    };
    SaveModuleDialogComponent.prototype.setFormValidators = function () {
        var _this = this;
        // Secondary category is only required when primary category is production or client.
        // In all other cases, we hide the secondary category.
        this.formPrimaryCategory.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) {
            switch (value) {
                case 'production':
                case 'client':
                    _this.formSecondaryCategory.setValidators([Validators.required]);
                    break;
                default:
                    _this.formSecondaryCategory.setValidators(null);
                    _this.formSecondaryCategory.setValue('');
                    break;
            }
        });
    };
    SaveModuleDialogComponent.prototype.setFormValues = function (saveModule) {
        // Never allow primary cateogry to save to the exports folder.
        // Exports is the single source of truth: models which have been exported from source model files,
        // and therefore should never be allowed to be overwritten.
        var category = (saveModule.primaryCategory === 'exports') ? 'preview' : saveModule.primaryCategory || 'preview';
        this.form.patchValue({
            primaryCategory: category,
            secondaryCategory: saveModule.secondaryCategory || '',
            name: saveModule.name || '',
            trimGraph: false,
            duplicateStates: false
        });
    };
    SaveModuleDialogComponent.prototype.save = function () {
        // Generate the save path
        var path = this.modulesService.generateModulePath(this.formPrimaryCategory.value, this.formSecondaryCategory.value, this.formName.value);
        // Generate the save configuration (save or duplicate)
        var saveConfig = new SaveModuleConfigModel();
        if (this.formDuplicateStates.value) {
            saveConfig.duplicate = true;
            // If we're duplicating the states, generate a new list of states for copying
            this.formStates.value.map(function (state) {
                if (state.include) {
                    saveConfig.namespaceMap[state.oldState] = state.newState;
                }
            });
        }
        // Generate the trim configuration. Currently only trimming visible is supported.
        var trimConfig = new TrimConfiguration();
        trimConfig.graph.hidden = this.formTrimGraph.value;
        // Send everything off for saving.
        this.store.dispatch(new SaveModule(path, saveConfig, trimConfig));
    };
    SaveModuleDialogComponent.prototype.handleNameChange = function (primaryCategory, secondaryCategory, name, duplicateStates) {
        var _this = this;
        this.modulePath = this.modulesService.generateModulePath(primaryCategory, secondaryCategory, name);
        if (this.formName.errors) {
            var _a = this.formName.errors, pattern = _a.pattern, required = _a.required;
            if (pattern || required) {
                return;
            }
        }
        if (this.modulePath && name.length) {
            this.modulesService.listContents(primaryCategory, secondaryCategory, name)
                .subscribe(function (results) {
                // When duplicating states, name is required
                _this.moduleExists = results.length > 0;
                var nameTaken = duplicateStates && _this.moduleExists;
                // Ensure valid name after async operation
                var invalid = !validRegex.test(name);
                if (nameTaken || invalid) {
                    _this.formName.setErrors({
                        invalid: true
                    });
                }
                else {
                    _this.formName.setErrors(null);
                }
                _this.formName.markAsDirty();
                _this.changeDetector.markForCheck();
            });
        }
    };
    SaveModuleDialogComponent.prototype.validateProductionSave = function (form) {
        var primaryCategory = form.get('primaryCategory');
        var confirmProduction = form.get('confirmProduction');
        if (!primaryCategory || !confirmProduction) {
            return null;
        }
        if (primaryCategory.value === 'production' && confirmProduction.value === false) {
            return { confirmProduction: true };
        }
        return null;
    };
    // Generates an array of server state name checks using the form controls
    SaveModuleDialogComponent.prototype.checkStateGroups = function () {
        var _this = this;
        var groups$ = this.formStates.controls.map(function (group) {
            return _this.validateStateGroup(group);
        });
        return groups$.length > 0 ? combineLatest.apply(void 0, __spread(groups$)) : of([]);
    };
    SaveModuleDialogComponent.prototype.validateStateGroup = function (stateGroup) {
        var validateStates = this.formDuplicateStates.value === true;
        var stateControl = stateGroup.get('newState');
        var includeControl = stateGroup.get('include');
        // If state control isn't toggled, auto validate to true
        if (!validateStates || includeControl.value === false) {
            return of({
                stateControl: stateControl,
                valid: true
            });
        }
        // If state control fails local validation, fail immediately without further checks
        if (stateControl.errors || stateControl.value.length === 0) {
            return of({
                stateControl: stateControl,
                valid: false
            });
        }
        // If all local checks pass, check server for availability
        return this.modulesService.getState(stateControl.value)
            .pipe(map(function (result) {
            var isValidString = validRegex.test(stateControl.value);
            return {
                stateControl: stateControl,
                valid: result.length === 0 && isValidString
            };
        }));
    };
    // Updates the form validation based on server validation checks
    SaveModuleDialogComponent.prototype.updateFormStates = function (validatedStates) {
        validatedStates.forEach(function (validatedState) {
            if (validatedState.valid) {
                validatedState.stateControl.setErrors(null);
                validatedState.stateControl.markAsDirty();
            }
            else {
                validatedState.stateControl.setErrors({ stateTaken: true });
            }
        });
        this.changeDetector.markForCheck();
    };
    SaveModuleDialogComponent.prototype.changeStatePrefix = function (newPrefix, mode) {
        this.formStates.controls.forEach(function (group) {
            var stateControl = group.get('newState');
            switch (mode) {
                case 'prepend':
                    stateControl.setValue(newPrefix + "_" + stateControl.value);
                    break;
                case 'replace':
                    var regex = new RegExp(/[^_]*/); // Match everything before underscore
                    var value = stateControl.value.replace(regex, newPrefix);
                    stateControl.setValue(value);
                    break;
            }
        });
    };
    __decorate([
        Select(ModulesState.getSaveModule),
        __metadata("design:type", Observable)
    ], SaveModuleDialogComponent.prototype, "saveModule$", void 0);
    __decorate([
        Select(ModulesState.getPrimaryCategoryOptions),
        __metadata("design:type", Observable)
    ], SaveModuleDialogComponent.prototype, "primaryCategoryOptions$", void 0);
    __decorate([
        Select(ModulesState.getSecondaryCategoryOptions),
        __metadata("design:type", Observable)
    ], SaveModuleDialogComponent.prototype, "secondaryCategoryOptions$", void 0);
    __decorate([
        Select(ModulesState.getSaving),
        __metadata("design:type", Observable)
    ], SaveModuleDialogComponent.prototype, "saving$", void 0);
    return SaveModuleDialogComponent;
}());
export { SaveModuleDialogComponent };
